import { Group } from "@mantine/core"
import { DateTime, icons } from "@/components/utils"
import { NoAnswer } from "./NoAnswer"
import type { IAnswerProps } from "./types"

interface IProps extends IAnswerProps {
  format?: string
}

export function AnswerDate({ answer, question, format = "L" }: IProps) {
  let value = answer?.value
  if (!value) return <NoAnswer />

  if (question.type == "personal") value = value * 1000 // convert from seconds to milliseconds
  return (
    <Group gap={4} fz="lg">
      <icons.Calendar size={20} />
      <DateTime timestamp={value || 0} format={format} />
    </Group>
  )
}
